<div class="row">
  <div class="col">
    <header>
      <div class="logo">
        <img class="img-fluid" src="assets/logo-hachkeru-color.png" alt="hackeru logo">
      </div>
    </header>
  </div>
</div>
